import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import Acuity from "./acuity/acuity";
import Organisaton from "./Organization/index";
import SearchFilter from "./SearchFilter";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  tabRoot: {
    borderWidth: 0,
    borderBottomWidth: 1,
    borderStyle: "solid",
    borderColor: "#ddd",
    "& .MuiTabs-flexContainer": {
      justifyContent: "flex-start",
    },
    "& .MuiTabs-indicator": {
      backgroundColor: "transparent",
    },
  },
  tabs: {
    fontSize: "18px",
    fontFamily: "Open Sans",
    textTransform: "none",
    "&.Mui-selected": {
      borderWidth: 0,
      borderBottomWidth: 1,
      borderStyle: "solid",
      // borderColor:
      //   sessionStorage.getItem("role") === "admin"
      //     ? "rgb(7, 127,131)"
      //     : "#981B1E",
      zIndex: 1,
      // color:
      //   sessionStorage.getItem("role") === "admin"
      //     ? "rgb(7, 127,131)"
      //     : "#981B1E",
    },
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <Box
      role='tabpanel'
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </Box>
  );
}

export default function ShortlistCoaching() {
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const globaluserData = useSelector((state) => state.commonReducer);
  const role = globaluserData?.role ;

  const tabArr = ["Acuity", "Organization"];
  const tabPanelArr = [<Acuity />, <Organisaton />];

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Grid container direction='row'>
        {role !== "admin" ? (
          <SearchFilter />
        ) : (
          <Grid item xs={12}>
            <Box my={5}>
              <Tabs
                value={value}
                onChange={handleChange}
                classes={{ root: classes.tabRoot }}
              >
                {tabArr.map((option) => (
                  <Tab
                    variant='contained'
                    classes={{ root: classes.tabs }}
                    label={option}
                  />
                ))}
              </Tabs>
              {tabPanelArr.map((option, index) => (
                <TabPanel value={value} index={index}>
                  {option}
                </TabPanel>
              ))}
            </Box>
          </Grid>
        )}
      </Grid>
    </>
  );
}
